export default __webpack_public_path__ + "static/media/floor8.0881e73c.png";